import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const DistributionChart = ({ chartData = {}, studentGrade }) => {
  const labels = ["A+", "A", "B+", "B", "C+", "C", "D"];

  // const dataValues = labels.map((label) => chartData[label] || 0);
  // const backgroundColors = labels.map((label) =>
  //   label === studentGrade ? "#50B6F2" : "#d3d3d3"
  // );

  const mergedChartData = Object.entries(chartData).reduce(
    (acc, [runtime_grade, count]) => {
      const mappedGrade =
        runtime_grade === "U" || runtime_grade === "E" ? "D" : runtime_grade;
      acc[mappedGrade] = (acc[mappedGrade] || 0) + count;
      return acc;
    },
    {}
  );

  const dataValues = labels.map((label) => mergedChartData[label] || 0);

  const backgroundColors = labels.map((label) =>
    label === studentGrade ||
    (studentGrade === "U" && label === "D") ||
    (studentGrade === "E" && label === "D")
      ? "#50B6F2"
      : "#D3D3D3"
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Students",
        data: dataValues,
        backgroundColor: backgroundColors,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          color: (context) => {
            const label = context.tick.label;
            if (
              label === studentGrade ||
              (studentGrade === "U" && label === "D") ||
              (studentGrade === "E" && label === "D")
            ) {
              return "#50B6F2";
            }
            return "#666";
          },
          font: (context) => {
            const label = context.tick.label;
            if (
              label === studentGrade ||
              (studentGrade === "U" && label === "D") ||
              (studentGrade === "E" && label === "D")
            ) {
              return { weight: "bold" };
            }
            return {};
          },
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
    },
  };

  return (
    <div style={{ height: "100px", width: "100%", maxWidth: "500px" }}>
      {/* <div style={{ height: "250px", width: "100%"}}> */}
      <Bar data={data} options={options} />
    </div>
  );
};

export default DistributionChart;
